module.exports = __webpack_public_path__ + "img/nr.b5239d74.svg";